// extracted by mini-css-extract-plugin
export default {"expand":"Expand_expand__gGgy6"};